// extracted by mini-css-extract-plugin
module.exports = {"categoryGroups":"style-module__categoryGroups___LSggQ","categoryGroup":"style-module__categoryGroup___1hFnN"};